const UtilLocalImage = {
  IMAGES: {
    LOGO: '/images/bns-logo.png',
    ABOUT: {
      BG: '/images/about.jpg',
    },
    BREAD: {
      LIST: '/images/bread-bg.jpg',
    },
    SAUCE: {
      LIST: '/images/sauce-bg.jpg',
    },
    DISH: {
      LIST: '/images/dish-bg.jpg',
    },
    DRINK: {
      LIST: '/images/drink-bg.jpg',
    },
    DESSERT: {
      LIST: '/images/dessert-bg.jpg',
    },
    BUNDLE: {
      LIST: '/images/bundle-bg.webp',
    },
    SNS: {
      INSTAGRAM: '/images/insta.png',
      KAKAO: '/images/kakao.png',
    },
    HOME: {
      LANDING_SECTION: {
        BG1: '/images/section-bread.jpg',
        BG2: '/images/section-coffee.jpg',
        BG3: '/images/section-salad.jpg',
        BG4: '/images/section-dish.jpg',
        BG5: '/images/section-dessert.jpg',
      },
    },
  },
  SVGS: {
    GIFT: '/svgs/gift.svg',
    SHEF: '/svgs/shef.svg',
    PANCAKE: '/svgs/pancake.svg',
  },
};

export default UtilLocalImage;
